import "../../Styles/General & MultiUse/AuthNavbar.css";
import ZGA from "../../Assets/ZGA.png";

const AuthNavbar = () => {
  return (
    <div className="authNavbar">
      <img src={ZGA} alt="The Zulaykha Global Academy" />
    </div>
  );
};

export default AuthNavbar;
